import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";
import * as Utils from "../../inc/Utils";
import Select from 'react-select'
import * as XLSX from "xlsx";
import DownloadTemplateUrl from "../../download/generate_project_import_template.xlsx";

export default function GenerateProjectImport() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'นำเข้าระบบ & ดาวน์โหลด';
    let btnTextLoading = 'กำลังบันทึก..';

    let [isLoading, setLoading] = React.useState(false);
    let [buttonText, setButtonText] = React.useState(btnTextDefault);
    const navigate = useNavigate();

    let [lang, setLanguage] = React.useState(null);
    let [projectType, setProjectType] = React.useState(null);
    let [agency, setAgency] = React.useState(null);
    let [platform, setPlatform] = React.useState(null);

    let [generateTypeCampaign, setGenerateTypeCampaign] = React.useState(false);
    let [generateTypeAdsSet, setGenerateTypeAdsSet] = React.useState(false);
    let [generateTypeUTM, setGenerateTypeUTM] = React.useState(false);

    React.useEffect(() => {
        (async function() {
            try {
                setGenerateTypeCampaign(true);

                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);

                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);

                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);

                const resAgency = await Utils.getAgencySlug();
                let newAgencies = [];
                if(resAgency) {
                    let newA = resAgency.find(e => e.id === roles.agencyId).items;
                    let ownerIds = [];
                    for(let a of newA) {
                        ownerIds.push(a.ownerId);
                    }
                    for(let ag of resAgency) {
                        if(ag.items.find(e => ownerIds.includes(e.ownerId))) {
                            newAgencies.push({
                                id: ag.id,
                                slug: ag.slug,
                                name: ag.name
                            })
                        }
                    }
                }
                setAgency(newAgencies);

                //-- Campaign
                await campaignDetail();

                //-- AdsSet
                await adssetDetail();

                //-- UTM
                await utmDetail();

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onCreate = async () => {

        let campaignParams = [];
        let generateTypeCampaignValidate = {};
        if(generateTypeCampaign && generateGroupCampaign.length > 0) {
            for(let n = 0; n < generateGroupCampaign.length; n++) {
                campaignParams[n] = [];
                for (let m = 0; m < excelDataAll.length; m++) {
                    campaignParams[n][m] = [];
                    let rs = excelDataAll[m];
                    let param = await getCampaignParams(n, {
                        slug: rs.lang.data + '-' + rs.projectType.data + '-' + rs.apData.slug,
                        projectId: rs.projectCode.data,
                        campaignId: rs.campaignId.data
                    });
                    if (param.params.length > 200) {
                        generateTypeCampaignValidate.message = 'Campaign Parameters [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (m+1) + '] ขนาดตัวอักษรต้องไม่เกิน 200';
                        break;
                    }
                    else {
                        campaignParams[n][m] = param;
                    }
                }
            }
        }

        let adssetParams = [];
        let generateTypeAdsSetValidate = {};
        if(generateGroupCampaign !== null && generateGroupCampaign.length > 0) {
            for(let n = 0; n < generateGroupCampaign.length; n++) {
                adssetParams[n] = [];
                for (let m = 0; m < excelDataAll.length; m++) {
                    adssetParams[n][m] = [];
                    for (let idx = 0; idx < generateGroupCampaign[n].masterAdssetItems.length; idx++) {
                        adssetParams[n][m][idx] = [];
                        const param = await getAdssetParams(n, m, idx);
                        if (param.params.length > 200) {
                            generateTypeAdsSetValidate.message = 'Ads Set Parameters [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (m+1) + '/' + (idx+1) + '] ขนาดตัวอักษรต้องไม่เกิน 200';
                            break;
                        }
                        else {
                            adssetParams[n][m][idx] = param;
                        }
                    }
                }
            }
        }

        let utmParams = [];
        let generateTypeUTMValidate = {};
        if(generateTypeUTM) {
            setLoading(true);
            setButtonText('กำลังตรวจสอบ UTM...');
            if(generateGroupCampaign !== null && generateGroupCampaign.length > 0) {
                for(let n = 0; n < generateGroupCampaign.length; n++) {
                    utmParams[n] = [];
                    for (let m = 0; m < excelDataAll.length; m++) {
                        utmParams[n][m] = [];
                        let excelRow = excelDataAll[m];
                        for (let idx = 0; idx < generateGroupCampaign[n].masterUtmItems.length; idx++) {
                            utmParams[n][m][idx] = [];
                            let sourceTypeIds = [];
                            let itemSource = generateGroupCampaign[n].masterUtmItems[idx].masterUtmItems;
                            let masterUtmItems = generateGroupCampaign[n].masterUtmItems[idx];

                            let params = masterUtmItems.utmPrevewParams;
                            params = params.replace('{campaignId}', excelRow.campaignId.data);
                            params = params.replace('{campaignName}', excelRow.campaignName.data);
                            params = params.replace('{projectId}', excelRow.projectCode.data);
                            params = params.replace('{projectName}', excelRow.projectCode.title);
                            params = params.replace('{projectSlug}', excelRow.apData.slug);
                            params = params.replace('{lineOAUrl}', excelRow.projectCode.lineOAID);
                            //langId.id + '-' + obj.project_type_slug + '-' + obj.project_slug

                            let templateRow = utmTemplate.filter(e => e.id === masterUtmItems.utmTemplateId)[0];
                            const templateSource = await Utils.getTemplateSourceById(templateRow.id);
                            const utm = await Utils.getUtmByIds(templateSource);

                            if(utm) {
                                for(let row of utm) {
                                    for(let rs of templateSource) {
                                        let sourceType = rs.source.sourceType;
                                        if(rs.source && rs.utmId === row.id) {
                                            let utmSourceTypeId = 0;
                                            let utmSourceId = rs.id;
                                            let utmSourceTypeText = null;
                                            let inputType = rs.source.inputType;
                                            if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {
                                                utmSourceTypeText = excelRow.campaignId.data;
                                            }
                                            else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {
                                                utmSourceTypeText = excelRow.campaignName.data;
                                            }
                                            else if(inputType === Utils.API_TYPE_PROJECT_ID) {
                                                utmSourceTypeText = excelRow.projectCode.data;
                                            }
                                            else if(inputType === Utils.API_TYPE_PROJECT_NAME) {
                                                utmSourceTypeText = excelRow.projectCode.title;
                                            }
                                            else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                                utmSourceTypeText = excelRow.apData.slug;
                                            }
                                            else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                                                // --
                                            }
                                            else if(inputType === Utils.API_TYPE_LINE_OAID) {
                                                utmSourceTypeText = excelRow.projectCode.lineOAID;
                                            }
                                            else {
                                                let find = sourceType.find(rs => {
                                                    return itemSource.find(it => {
                                                        if(parseInt(it.utmSourceTypeId) === parseInt(rs.id)) {
                                                            return it;
                                                        }
                                                    });
                                                });
                                                if(find) {
                                                    utmSourceId = find.utmSourceId;
                                                    utmSourceTypeId = find.id;
                                                    utmSourceTypeText = find.name;
                                                }
                                            }

                                            sourceTypeIds.push({
                                                utmSourceId: utmSourceId,
                                                utmSourceTypeId: utmSourceTypeId,
                                                utmSourceTypeText: utmSourceTypeText,
                                                inputType: inputType
                                            });
                                        }
                                    }
                                }
                            }

                            utmParams[n][m][idx] = {
                                ids: sourceTypeIds,
                                param: params
                            };
                        }
                    }
                }
            }
        }

        if(generateTypeCampaignValidate.message) {
            setLoading(false);
            setButtonText(btnTextDefault);
            toast.error(generateTypeCampaignValidate.message);
        }
        else if(generateTypeAdsSetValidate.message) {
            setLoading(false);
            setButtonText(btnTextDefault);
            toast.error(generateTypeAdsSetValidate.message);
        }
        else if(generateTypeUTMValidate.message) {
            setLoading(false);
            setButtonText(btnTextDefault);
            toast.error(generateTypeUTMValidate.message);
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setLoading(true);
                            setButtonText(btnTextLoading);

                            let bulkBody = [];

                            if(generateGroupCampaign && generateGroupCampaign.length > 0) {
                                for (let n = 0; n < generateGroupCampaign.length; n++) {
                                    for (let m = 0; m < excelDataAll.length; m++) {
                                        let rs = excelDataAll[m];
                                        let url = rs.apData.url;
                                        for (let idx = 0; idx < generateGroupCampaign[n].masterUtmItems.length; idx++) {
                                            let masterUtmItems = generateGroupCampaign[n].masterUtmItems[idx];
                                            let body = {
                                                campaignTemplateId: null,
                                                typeId: Utils.GENERATE_TYPE_PROJECT,
                                                lang: rs.lang.data ?? null,
                                                projectTypeId: rs.projectType.data ?? null,
                                                projectId: rs.projectCode.data ?? null,
                                                campaignDate: rs.campaignDate && rs.campaignDate.data ? new Date(rs.campaignDate.data) : null,
                                                campaignId: rs.campaignId && rs.campaignId.data ? rs.campaignId.data : null,
                                                agencyId: generateGroupCampaign[n].agencyId,
                                                adsPlatformId: generateGroupCampaign[n].adsPlatformId ?? null,
                                                generateGroupCampaignId: generateGroupCampaign[n].id,
                                                url: url,
                                                createdBy: userId,
                                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                                            };

                                            if (generateTypeCampaign) {
                                                body.generateTypeCampaign = 1;
                                                body.paramsCampaign = campaignParams[n][m].params;
                                                body.campaignSourceTypeIds = campaignParams[n][m].data;
                                            }

                                            if (generateTypeAdsSet) {
                                                body.generateTypeAdsset = 1;
                                                body.paramsAdsset = adssetParams[n][m][idx].params;
                                                body.adssetSourceTypeIds = adssetParams[n][m][idx].data;

                                                let adsNamingSetNameTypeId = null;
                                                if (generateGroupCampaign[n].masterAdssetItems[idx]) {
                                                    adsNamingSetNameTypeId = masterUtmItems.adsNamingSetNameTypeId;
                                                }
                                                body.adsNamingSetNameTypeId = adsNamingSetNameTypeId;
                                            }

                                            if (generateTypeUTM) {
                                                //Main URL
                                                url = url.toString().trim();

                                                let hashtagText = '';
                                                if(masterUtmItems.hashtag) {
                                                    hashtagText = hashtagList.filter(e => e.id === masterUtmItems.hashtag)[0].name;
                                                }

                                                //Create Params
                                                let params = utmParams[n][m][idx].param;
                                                params = params + (hashtagText ? '#' + hashtagText : '');
                                                let urlParam = url + '?' + params;

                                                //Create Short URL (Rebrandly)
                                                let rebrandlyUrl = null;
                                                if (urlParam && rebrandlyChecked) {
                                                    const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                                                    rebrandlyUrl = resShortUrl.shortUrl;
                                                    //rebrandlyUrl = 'rebrandlyUrl-XXX';
                                                }

                                                //Create Short URL (Short.IO)
                                                let shortioUrl = null;
                                                if (urlParam && shortioChecked) {
                                                    const resShortUrl = await Utils.createShortioShortURL(urlParam);
                                                    shortioUrl = resShortUrl.path;
                                                    //shortioUrl = 'shortioUrl-XXX';
                                                }

                                                body.generateTypeUTM = 1;
                                                body.paramsUTM = params;
                                                body.utmTemplateId =  masterUtmItems.utmTemplateId;
                                                body.utmGroupId = null;
                                                body.utmGroupItemId = null;
                                                body.hashtag = hashtagText ? hashtagText : null;
                                                body.shortUrl = rebrandlyUrl;
                                                body.shortioUrl = shortioUrl;
                                                body.utmSourceTypeIds = utmParams[n][m][idx].ids;
                                            }

                                            bulkBody.push(body);
                                        }
                                    }
                                }
                            }

                            fetch(Config.url.API_URL + '/api/generate/createBulks', {
                                method: 'POST',
                                body: JSON.stringify(bulkBody),
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if (response.ok) {
                                    return response.json();
                                } else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(async result => {
                                if (result) {
                                    await exportExcel(bulkBody);
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/generateProject', {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            });
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {
                            setLoading(false);
                            setButtonText(btnTextDefault);
                        }
                    }
                ]
            });
        }
    };

    async function exportExcel(rows) {
        let jsonData = [];
        rows.map(row => {
            let utmUrl = '';
            let campaignUrl = '';
            let adssetUrl = '';
            if(row.generateTypeUTM) {
                utmUrl = row.url + '?' + row.paramsUTM + (row.addLine ? '#addline':'');
            }
            if(row.generateTypeCampaign) {
                campaignUrl = row.paramsCampaign;
            }
            if(row.generateTypeAdsset) {
                adssetUrl = row.paramsAdsset;
            }

            let objective = campaignUrl ? campaignUrl.split('|')[2] : '-';
            let target_type = adssetUrl ? adssetUrl.split('|')[2] : '-';
            jsonData.push({
                Type: Utils.generateUTMType(row.typeId),
                Lang: row.lang,
                ProjectType: row.projectTypeId,
                ProjectCode: row.projectId,
                CampaignID: row.campaignId,
                CampaignDate: row.campaignDate ? new Date(row.campaignDate) : '',
                Objective: objective.split('_')[4],
                TargetType: target_type.split('_')[0],
                CampaignNaming: campaignUrl,
                AdsetNaming: adssetUrl,
                UTM: utmUrl,
                REBRADLY_URL: row.shortUrl ?? '',
                SHORT_IO_URL: row.shortioUrl && shortio.domain ? "https://" + shortio.domain + '/' + row.shortioUrl : '',
                CREATED_BY: roles.loginName,
                CREATED_DATE: Utils.dateYMDHI(new Date())
            });
        });
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "generate_project_export_" + Utils.getDate() + ".xlsx");
    }

    //region -- Campaign
    let [campaignAdsNaming, setCampaignAdsNaming] = React.useState(null);

    let [generateGroup, setGenerateGroup] = React.useState(null);
    let [generateGroupId, setGenerateGroupId] = React.useState(null);
    let [generateGroupCampaign, setGenerateGroupCampaign] = React.useState(null);
    let [isPreviewing, setPreviewing] = React.useState(false);

    const campaignDetail = async () => {
        const resGenerateGroup = await Utils.getGenerateGroup();
        if(resGenerateGroup) {
            setGenerateGroup(resGenerateGroup.filter(e => e.typeId === Utils.GENERATE_TYPE_PROJECT));
        }

        const resAdsNaming = await Utils.getAdsNamingCampaign();
        setCampaignAdsNaming(resAdsNaming);
    };
    function getCampaignParams(n, param) {
        let textParams = [];
        let sourceIds = [];

        for(let rs of generateGroupCampaign[n].items) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(campaignAdsNaming.length > 0) {
            campaignAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: param.slug,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        // --
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });

                        if(row.name === 'Objective') {
                            let platformName = '';
                            if(platform && generateGroupCampaign[n].adsPlatformId) {
                                platformName = platform.filter(e => e.id === generateGroupCampaign[n].adsPlatformId)[0].name;
                                textParams.push({
                                    adsNamingSourceId: null,
                                    adsNamingId: null,
                                    text: platformName,
                                    inputType: null
                                });
                            }
                        }
                    }
                }
            });
        }

        let agencySlug = '';
        if(generateGroupCampaign[n]) {
            agencySlug = agency.filter(e => e.id === generateGroupCampaign[n].agencyId)[0].slug;
        }

        let params = agencySlug + '|' + param.projectId + '|' + textParams.map(x => x.text).join('_') + '_[ST]|' + (param.campaignId ? param.campaignId:'');

        return {
            params: params,
            data: textParams
        };
    }
    function getCampaignPreview(generateGroupCampaign) {
        let textParams = [];
        let sourceIds = [];

        for(let rs of generateGroupCampaign.items) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(campaignAdsNaming.length > 0) {
            campaignAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: '{slugProject}',
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        // --
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });

                        if(row.name === 'Objective') {
                            let platformName = '';
                            if(platform && generateGroupCampaign.adsPlatformId) {
                                platformName = platform.filter(e => e.id === generateGroupCampaign.adsPlatformId)[0].name;
                                textParams.push({
                                    adsNamingSourceId: null,
                                    adsNamingId: null,
                                    text: platformName,
                                    inputType: null
                                });
                            }
                        }
                    }
                }
            });
        }

        let agencySlug = '';
        if(generateGroupCampaign) {
            agencySlug = agency.filter(e => e.id === generateGroupCampaign.agencyId)[0].slug;
        }

        let params = agencySlug + '|{Project ID}|' + textParams.map(x => x.text).join('_') + '_[ST]|{campaignId}';

        return params;
    }
    const onChangeGenerateGroupId = async (obj) => {
        setGenerateGroupId(null);
        setPreviewing(true);
        if(obj && obj.id) {
            setGenerateGroupId(obj);
            const generateGroupList = await Utils.getGenerateGroupCampaign(obj.id);
            if(generateGroupList) {
                for (let row of generateGroupList) {
                    if (row.master.length > 0) {
                        row.campaignPreviewParams = getCampaignPreview(row);

                        let checkAssetItem = row.master.filter(e => e.masterAdssetItems);
                        if (checkAssetItem.length > 0) {
                            for (let a of row.master) {
                                a.addsetPrevewParams = getAdssetPreview(row, a);
                            }
                            setGenerateTypeAdsSet(true);
                            row.masterAdssetItems = checkAssetItem;
                        }
                        let checkUtmItem = row.master.filter(e => e.masterUtmItems);
                        if (checkUtmItem.length > 0) {
                            for (let u of row.master) {
                                u.utmPrevewParams = await getUTMPreview(row, u);
                            }
                            setGenerateTypeUTM(true);
                            row.masterUtmItems = checkUtmItem;
                        }
                    }
                }

                let newGenerateGroupList = generateGroupList.filter(e => e.master.length > 0);
                setGenerateGroupCampaign(newGenerateGroupList);
                setPreviewing(false);
            }
        }
    };
    //endregion

    //region -- Ads Set
    let [adsNamingSetNameType, setAdsNamingSetNameType] = React.useState(null);
    let [adssetAdsNaming, setAdssetAdsNaming] = React.useState(null);

    const adssetDetail = async () => {
        const resSetNameType = await Utils.getAdsNamingSetNameType();
        setAdsNamingSetNameType(resSetNameType);

        const resAdssetName = await Utils.getAdsNamingSetName();
        if(resAdssetName.length > 0) {
            let newAdsNaming = [];
            if(resAdssetName) {
                newAdsNaming = resAdssetName.filter(row => row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROMOTION && row.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL);
            }
            setAdssetAdsNaming(newAdsNaming);
        }
    };
    async function getAdssetParams(n, m, idx) {
        let textParams = [];
        let sourceIds = [];

        for(let rs of generateGroupCampaign[n].masterAdssetItems[idx].masterAdssetItems) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(adssetAdsNaming.length > 0) {
            adssetAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: excelDataAll[m].lang.data + '-' + excelDataAll[m].projectType.data + '-' + excelDataAll[m].apData.slug,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        //--
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });
                    }
                }
            });
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        //Fixed Slug Project
        let slugProject = textParams.length > 1 ? textParams[1].text:'';

        let platformName = '';
        if(platform && generateGroupCampaign[n].adsPlatformId) {
            platformName = '_' + platform.filter(e => e.id === generateGroupCampaign[n].adsPlatformId)[0].name;
        }

        let adsNamingSetNameTypeText = '';
        if(generateGroupCampaign[n].masterAdssetItems[idx] && generateGroupCampaign[n].masterAdssetItems[idx].adsNamingSetNameTypeId) {
            let adsNamingSetNameTypeRow = adsNamingSetNameType.filter(e => e.id === generateGroupCampaign[n].masterAdssetItems[idx].adsNamingSetNameTypeId)[0];
            adsNamingSetNameTypeText = adsNamingSetNameTypeRow.name
        }

        let params = bg + '_' + slugProject + '|' + textParams.slice(2).map(x => x.text).join('_') + platformName + '|' + adsNamingSetNameTypeText + '_[ST]';

        return {
            params: params,
            data: textParams,
            //success: sourceTypeAllIds.length === selectSourceTypeIds.length
        };
    }
    function getAdssetPreview(generateGroupCampaign, adssetItem) {
        let textParams = [];
        let sourceIds = [];

        for(let rs of adssetItem.masterAdssetItems) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(adssetAdsNaming.length > 0) {
            adssetAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        //--
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        //--
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });
                    }
                }
            });
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        let platformName = '';
        if(platform && generateGroupCampaign.adsPlatformId) {
            platformName = '_' + platform.filter(e => e.id === generateGroupCampaign.adsPlatformId)[0].name;
        }

        let adsNamingSetNameTypeText = '';
        if(adssetItem && adssetItem.adsNamingSetNameTypeId) {
            let adsNamingSetNameTypeRow = adsNamingSetNameType.filter(e => e.id === adssetItem.adsNamingSetNameTypeId)[0];
            adsNamingSetNameTypeText = adsNamingSetNameTypeRow.name
        }

        let params = bg + '_{slugProject}|' + textParams.slice(1).map(x => x.text).join('_') + platformName + '|' + adsNamingSetNameTypeText + '_[ST]';

        return params;
    }
    //endregion

    //region -- UTM
    let [utmTemplate, setUtmTemplate] = React.useState(null);
    let [hashtagList, setHashtagList] = React.useState(null);
    let [rebrandly, setRebrandly] = React.useState(null);
    let [shortio, setShortIO] = React.useState(null);
    let [rebrandlyChecked, setRebrandlyChecked] = React.useState(false);
    let [shortioChecked, setShortioChecked] = React.useState(false);

    const utmDetail = async () => {
        const resTemplate = await Utils.getTemplate({agencyId: roles.agencyId});
        setUtmTemplate(resTemplate);
        const resRebrandly = await Utils.getRebrandly();
        setRebrandly(resRebrandly);
        const resShortIO = await Utils.getShortIO();
        setShortIO(resShortIO);
        const resHashtag = await Utils.getHashtag();
        setHashtagList(resHashtag);
    };
    async function getUTMPreview(generateGroupCampaign, utmItem) {
        let sourceTypeIdsParam = [];
        let itemSource = utmItem.masterUtmItems;

        let templateRow = utmTemplate.filter(e => e.id === utmItem.utmTemplateId)[0];

        if(templateRow && templateRow.id) {
            const templateSource = await Utils.getTemplateSourceById(templateRow.id);
            if(templateSource) {
                const utm = await Utils.getUtmByIds(templateSource);
                if(utm) {
                    for(let row of utm) {
                        for(let rs of templateSource) {
                            let sourceType = rs.source.sourceType;
                            if(rs.source && rs.utmId === row.id) {
                                let inputType = rs.source.inputType;
                                if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {
                                    sourceTypeIdsParam.push('x:CP' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {
                                    sourceTypeIdsParam.push('x:CN' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_PROJECT_ID) {
                                    sourceTypeIdsParam.push('x:PJI' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_PROJECT_NAME) {
                                    sourceTypeIdsParam.push('x:PJN' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                    sourceTypeIdsParam.push('x:PJS' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                                    // --
                                }
                                else if(inputType === Utils.API_TYPE_LINE_OAID) {
                                    sourceTypeIdsParam.push('x:LINEOA' + rs.source.id);
                                }
                                else {
                                    let find = sourceType.find(rs => {
                                        return itemSource.find(it => {
                                            if(parseInt(it.utmSourceTypeId) === parseInt(rs.id)) {
                                                return it;
                                            }
                                        });
                                    });
                                    if(find && find.id) {
                                        sourceTypeIdsParam.push(find.id);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        let params = await Utils.generateParams({}, sourceTypeIdsParam);

        return params;
    }
    //endregion

    //region Upload
    let btnTextUploadDefault = 'อัพโหลด';
    let btnTextUploading = 'กำลังอัพโหลด..';
    let [isUploading, setUploading] = React.useState(false);
    let [isUploaded, setUploaded] = React.useState(false);
    let [excelFile, setExcelFile] = React.useState(false);
    let [excelDataAll, setExcelDataAll] = React.useState([]);
    let [excelDataError, setExcelDataError] = React.useState([]);

    const onDownload = () => {
        const a = document.createElement('a');
        a.href = DownloadTemplateUrl;
        a.download = DownloadTemplateUrl.split('/').pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const resetUpload = () => {
        window.location.reload();
    };

    const onSelectFile = (e) => {
        setExcelFile(e);
    };

    const onUpload = async () => {
        if(excelFile && excelFile.target.value) {

            if(!excelFile || typeof excelFile.target === 'undefined') {
                toast.error("กรุณาระบุ Excel File");
            }
            else {
                setUploading(true);

                const [file] = excelFile.target.files;
                const reader = new FileReader();

                reader.onload = async (evt) => {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, {type: "binary"});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, {header: 1});

                    if(data) {
                        let row = data.split('\n');
                        let header = row[0];
                        let cols = header.split(',');
                        if(cols[0] !== 'Lang') {
                            setUploading(false);
                            toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                        }
                        else if(cols[1] !== 'Project Type') {
                            setUploading(false);
                            toast.error("Column 2 : ต้องเป็น(ชื่อ) Project Type");
                        }
                        else if(cols[2] !== 'Project Code') {
                            setUploading(false);
                            toast.error("Column 3 : ต้องเป็น(ชื่อ) Project Code");
                        }
                        else if(cols[3] !== 'Campaign ID') {
                            setUploading(false);
                            toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                        }
                        else if(cols[4] !== 'Campaign Date') {
                            setUploading(false);
                            toast.error("Column 5 : ต้องเป็น(ชื่อ) Campaign Date");
                        }
                        else {
                            let excelArrAll = [];
                            let excelArrError = [];
                            let statusError = [];
                            for(let i=1;i<row.length;i++) {
                                let cols = row[i].split(',');
                                let colLang = cols[0].toString().trim();
                                let colProjectType = cols[1].toString().trim();
                                let colProjectCode = cols[2].toString().trim();
                                let colCampaignId = cols[3].toString().trim();
                                let colCampaignDate = Utils.dateFromExcel(cols[4].toString().trim());

                                let message = [];

                                //-------------------------------

                                let statusLang = false;
                                if(lang) {
                                    statusLang = lang.filter(e => e.id === colLang).length > 0;
                                }
                                if(!colLang) {
                                    message.push('Please input Lang');
                                }
                                if(!statusLang) {
                                    message.push('Invalid Lang');
                                }
                                statusError.push(statusLang);

                                //-------------------------------

                                let statusProjectType = false;
                                if(projectType) {
                                    statusProjectType = projectType.filter(e => e.id === colProjectType).length > 0;
                                }
                                if(!colProjectType) {
                                    message.push('Please input Project Type');
                                }
                                if(!statusProjectType) {
                                    message.push('Invalid Project Type');
                                }
                                statusError.push(statusProjectType);

                                //-------------------------------

                                let statusProjectCode = false;
                                let projectSlug = '';
                                let projectUrl = '';
                                let projectTitle = '';
                                let projectTypeSlug = '';
                                let projectLineOAID = '';
                                if(colLang && colProjectType) {
                                    const resProject = await Utils.getProjectCodeImport(colLang, colProjectType);
                                    if(resProject.statusCode === 200) {
                                        if (resProject && resProject.data && resProject.data.length > 0) {
                                            let projectData = resProject.data.filter(e => e.project_code === colProjectCode)[0];
                                            if (projectData) {
                                                projectTitle = projectData.project_title;
                                                projectTypeSlug = projectData.project_type_slug;
                                                projectLineOAID = projectData.line_oaid;
                                                projectSlug = projectData.project_slug;
                                                projectUrl = projectData.project_url;
                                                statusProjectCode = projectSlug !== '' && projectUrl !== '';
                                            } else {
                                                message.push('API : Not found project data with {' + colProjectCode + '}');
                                            }
                                        } else {
                                            message.push('API /api/projects/urls : Not found data');
                                        }
                                    }
                                    else {
                                        message.push('API /api/projects/urls : statusCode: '  + resProject.statusCode + ', message: ' + resProject.message);
                                    }
                                }
                                statusError.push(statusProjectCode);

                                //-------------------------------

                                let statusCampaignDate = true;
                                if(colCampaignDate) {
                                    statusCampaignDate = moment(colCampaignDate, 'YYYY-MM-DD').isValid();
                                    if(!statusCampaignDate) {
                                        message.push('Invalid Campaign Date');
                                    }
                                }
                                statusError.push(statusCampaignDate);

                                //-------------------------------

                                let statusCampaignId = false;
                                let campaignName = '';
                                if(colLang && colProjectType && colProjectCode) {
                                    const resCampaign = await Utils.getCampaignImport({
                                        langId: colLang,
                                        projectType: colProjectType,
                                        projectCode: colProjectCode,
                                        campaignDate: statusCampaignDate ? colCampaignDate : null
                                    });
                                    let campaignList = [];
                                    campaignList.push({
                                        campaign_id: '0638A01',
                                        campaign_name: 'NonDefine'
                                    });
                                    if (resCampaign.statusCode === 200) {
                                        if (resCampaign.data && resCampaign.data.length > 0 && resCampaign.data[0].promotions) {
                                            for (let rs of resCampaign.data[0].promotions) {
                                                campaignList.push({
                                                    campaign_id: rs.campaign_id,
                                                    campaign_name: rs.campaign_name
                                                });
                                            }
                                            let campaignRow = campaignList.filter(e => e.campaign_id === colCampaignId)[0];
                                            if (campaignRow && campaignRow.campaign_id) {
                                                statusCampaignId = true;
                                                campaignName = campaignRow.campaign_name;
                                            } else {
                                                statusCampaignId = false;
                                                message.push('Invalid Campaign ID');
                                            }
                                        } else {
                                            message.push('API /api/projects/campaigns : Not found data');
                                        }
                                    } else {
                                        statusCampaignDate = false;
                                        message.push('API /api/projects/campaigns : statusCode: ' + resCampaign.statusCode + ', message: ' + resCampaign.message);
                                    }
                                }
                                statusError.push(statusCampaignId);

                                //-------------------------------

                                if(!statusLang || !statusProjectType || !statusProjectCode || !statusCampaignDate || !statusCampaignId) {
                                    excelArrError.push({
                                        lang: {
                                            data: colLang,
                                            status: statusLang,
                                        },
                                        projectType: {
                                            data: colProjectType,
                                            status: statusProjectType,
                                        },
                                        projectCode: {
                                            data: colProjectCode,
                                            status: statusProjectCode,
                                            typeSlug: projectTypeSlug,
                                            title: projectTitle,
                                            lineOAID: projectLineOAID
                                        },
                                        campaignId: {
                                            data: colCampaignId,
                                            status: statusCampaignId
                                        },
                                        campaignName: {
                                            data: campaignName
                                        },
                                        campaignDate: {
                                            data: colCampaignDate,
                                            status: statusCampaignDate
                                        },
                                        apData: {
                                            url : projectUrl,
                                            slug: projectSlug,
                                            status: true,
                                            message: message
                                        }
                                    });
                                }

                                excelArrAll.push({
                                    lang: {
                                        data: colLang,
                                        status: statusLang,
                                    },
                                    projectType: {
                                        data: colProjectType,
                                        status: statusProjectType,
                                    },
                                    projectCode: {
                                        data: colProjectCode,
                                        status: statusProjectCode,
                                        typeSlug: projectTypeSlug,
                                        title: projectTitle,
                                        lineOAID: projectLineOAID
                                    },
                                    campaignId: {
                                        data: colCampaignId,
                                        status: statusCampaignId
                                    },
                                    campaignName: {
                                        data: campaignName
                                    },
                                    campaignDate: {
                                        data: colCampaignDate,
                                        status: statusCampaignDate
                                    },
                                    apData: {
                                        url : projectUrl,
                                        slug: projectSlug,
                                        status: true,
                                        message: message
                                    }
                                });
                            }

                            setExcelDataAll(excelArrAll);
                            setExcelDataError(excelArrError);
                            setGenerateTypeCampaign(statusError.every(v => v === true));
                        }
                    }
                    setUploading(false);
                    setUploaded(true);
                };
                reader.readAsBinaryString(file);
            }

        }
        else {
            toast.error("กรุณาระบุ Excel File");
        }
    };
    //endregion

    return (

        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Project</div>
                    <span className="ms-1">/</span> <span className="text-muted">Import</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12">
                        <button type="button" className="btn btn-sm btn-success" onClick={onDownload}><span><Icon.Download/> ดาวน์โหลดเทมเพลต</span></button>
                    </div>

                    <div className="col-12 mt-3">
                        <label htmlFor="generateGroupId" className="form-label">Group <span className="text-danger">*</span></label>
                        <Select
                            isDisabled={!generateTypeCampaign}
                            classNamePrefix="form-select-search"
                            options={generateGroup}
                            onChange={(event) => onChangeGenerateGroupId(event)}
                            value={generateGroupId}
                            getOptionValue={(option) => `${option.id}`}
                            getOptionLabel={(option) => `${option.name}`}
                        />
                    </div>

                    <div className="col-12 mt-3">
                        <label htmlFor="generateGroupId" className="form-label">Campaign</label>
                        <div className={"ms-2 spinner-grow spinner-grow-sm" + (isPreviewing ? '':' d-none')}></div>
                        <div style={{maxHeight: '600px', overflowY: 'auto'}}>
                            <table className={"table table-bordered table-yellow" + (isPreviewing ? ' d-none':'')}>
                                <thead>
                                <tr>
                                    <th width="150">Name</th>
                                    <th>Format</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    generateGroupCampaign && generateGroupCampaign.length ?
                                        generateGroupCampaign.map((row, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{row.name}</td>
                                                    <td>
                                                        <div className="fw-bold mt-1">Campaign</div>
                                                        <div className="campaign-bg p-1">{row.campaignPreviewParams}</div>
                                                        <div className="fw-bold mt-1">Ads Set</div>
                                                        {
                                                            row.masterAdssetItems.map((rs, i) => {
                                                                return (
                                                                    <div className="adsset-bg p-1 mb-2">
                                                                        <span className="small fw-bold">{rs.name}</span>
                                                                        <p className="mb-0">{rs.addsetPrevewParams}</p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <div className="fw-bold mt-1">UTM</div>
                                                        {
                                                            row.masterUtmItems.map((rs, j) => {
                                                                return (
                                                                    <div className="utm-bg p-1 mb-2">
                                                                        <span className="small fw-bold">{rs.name}</span>
                                                                        <p className="mb-0">{rs.utmPrevewParams}</p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={2} className="text-center">-</td></tr>
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-12 mt-3">
                        <label htmlFor="excelFilex" className="form-label">Excel File <span className="text-danger">*</span></label>
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <div className="input-group mb-3">
                                    <input type="file" className="form-control" id="excelFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e) => {onSelectFile(e)}} disabled={isUploading || isUploaded} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <button type="button" className={"btn btn-success " + (isUploaded ? 'd-none':'d-block')} onClick={onUpload} disabled={isUploading}><span
                                    className={isUploading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isUploading ? btnTextUploading : btnTextUploadDefault}</button>
                                <button type="button" className={"btn btn-secondary " + (!isUploaded ? 'd-none':'d-block')} onClick={resetUpload}>เริ่มใหม่</button>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 mt-2">
                        <label htmlFor="excelFilex" className="form-label">Generate Result</label>
                        <div style={{maxHeight: '600px', overflowY: 'auto'}}>
                            <table className="table table-bordered table-green">
                                <thead>
                                    <tr>
                                        <th className="text-center" width="60">Lang <span className="text-danger">*</span></th>
                                        <th width="100" className="text-center">Project Type <span className="text-danger">*</span></th>
                                        <th width="120" className="text-center">Project Code <span className="text-danger">*</span></th>
                                        <th width="100" className="text-center">Campaign ID</th>
                                        <th width="120" className="text-center">Campaign Date</th>
                                        <th>URL</th>
                                        <th>Project Slug</th>
                                        <th className="text-center" width="60">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    excelDataAll.length ?
                                        excelDataAll.map((row, index) => {
                                            let status = row.lang.status && row.projectType.status && row.projectCode.status && row.campaignId.status && row.campaignDate.status;

                                            return (
                                                <tr key={index} className={""+ (!status ? ' bg-danger-light' : '')}>
                                                    <td className={"text-center" + (!row.lang.status ? ' text-danger':'')}>{row.lang.data ?? '-'}</td>
                                                    <td className={"text-center" + (!row.projectType.status ? ' text-danger':'')}>{row.projectType.data ?? '-'}</td>
                                                    <td className={"text-center" + (!row.projectCode.status ? ' text-danger':'')}>{row.projectCode.data ?? '-'}</td>
                                                    <td className={"text-center" + (!row.campaignId.status ? ' text-danger':'')}>{row.campaignId.data ? row.campaignId.data : 'กรุณาระบุ'}</td>
                                                    <td className={"text-center" + (!row.campaignDate.status ? ' text-danger':'')}>{row.campaignDate.data}</td>
                                                    <td className={"text-left" + (!row.apData.status || row.apData.message.length > 0 ? ' text-danger':'')} style={{ whiteSpace: 'pre-line' }}>{status ? row.apData.url : (row.apData.message ? row.apData.message.join('\n') : '')}</td>
                                                    <td className="text-center">{row.apData.slug}</td>
                                                    <td className={"text-center " + (status ? ' text-success' : ' text-danger')}>{status ? <Icon.CheckCircle /> : <Icon.XCircle />}</td>
                                                </tr>
                                            )
                                        }) : null
                                }
                                {
                                    excelDataError.length === 0 && excelDataAll.length === 0 && !isUploading ? <tr><td colSpan={8} className="text-center">-</td></tr>:''
                                }
                                {
                                    isUploading ?  <tr><td colSpan={8} className="text-center"><span className="spinner-grow spinner-grow-sm"></span></td></tr>:''
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className={"col-12 mt-2" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && rebrandly && rebrandly.status===1 && rebrandly.apiKey && rebrandly.endpoint ? '':' d-none')}>
                        <label htmlFor="rebrandlyUrlx" className="form-label">Create Short URL (Rebrandly)</label>
                        <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" name="rebrandlyUrlChecked" id="rebrandlyUrl" defaultChecked={rebrandlyChecked} onChange={e => setRebrandlyChecked(e.target.checked)} />
                            <label className="form-check-label" htmlFor="rebrandlyUrl"></label>
                        </div>
                    </div>

                    <div className={"col-12 mt-2" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && shortio && shortio.status===1 && shortio.apiKey && shortio.endpoint ? '':' d-none')}>
                        <label htmlFor="shortioUrlx" className="form-label">Create Short URL (Short.IO)</label>
                        <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" name="shortioUrlChecked" id="shortioUrl" defaultChecked={shortioChecked} onChange={e => setShortioChecked(e.target.checked)} />
                            <label className="form-check-label" htmlFor="shortioUrl"></label>
                        </div>
                    </div>

                    <div className="col-12 mt-4">
                        <button type="button" className="btn btn-success" onClick={onCreate} disabled={isLoading || excelDataError.length !== 0 || excelDataAll.length === 0 || !generateGroupCampaign || generateGroupCampaign.length === 0}><span
                            className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> <Icon.CloudArrowUp siize={16} /> {buttonText}</button>
                        <NavLink className="btn btn-sm btn-light ms-2" to='/generateProject'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                        <Toaster position="bottom-right" />
                    </div>
                </div>
            </div>
        </main>
    );
} 